import { ModelMixin, Model } from '../../../domain/model/common/model.class';
import { ProfileStatusModel } from '../../profile-status/model/profile-status.model';

class VerificationDetailsRaw {
    verifiedData: string;
    notes: string;
    verifiedByName: string;
    verifiedDate: string;
    section: string;
    subSection?: string;
}

export class VerificationDetailsModel extends ModelMixin() implements Model<VerificationDetailsModel> {
    TYPE = VerificationDetailsModel;
    verifiedData: {
        description: string,
        extendedDescription: {
            report: string,
            file: string,
            date: Date
        }[]
    };
    notes: string;
    verifiedByName: string;
    verifiedDate: Date;
    section: string;
    sectionName: string;
    subSection?: string;

    constructor(jsonData: VerificationDetailsRaw|any = {}) {
        super();
        const parsedData = {
            ...jsonData,
            verifiedData: JSON.parse(jsonData.verifiedData),
            verifiedDate: new Date(jsonData.verifiedDate),
        };
        if (parsedData.verifiedData.extendedDescription) {
            for (let extDesc of parsedData.verifiedData.extendedDescription) {
                if (extDesc.date) {
                    extDesc.date = new Date(extDesc.date);
                }
            }
        }
        Object.assign(this, parsedData);
    }
}

export class VerificationSummaryModel extends ModelMixin() implements Model<VerificationSummaryModel> {
    TYPE = VerificationSummaryModel;
    summary: Array<VerificationDetailsModel>;
    profileStatus: ProfileStatusModel;

    constructor(jsonData: any = {}) {
        super();
        this.summary = new Array<VerificationDetailsModel>();
        this.profileStatus = new ProfileStatusModel(jsonData.profileStatus);
        jsonData.verification.forEach(verification => {
            this.summary.push(new VerificationDetailsModel(verification));
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/verification/model/verification.model.ts